import React from 'react';
import MyBetsLayout2 from './my-bets-layout-2/MyBetsLayout2';
import { getConfiguration } from '../utils';
import MyBetsLayout1 from './MyBetsLayout1';

function MyBets(props) {
	const conf = getConfiguration();
    const showOldLayout = conf.mbt == null || conf.mbt === 'V1';

    return (
		<>
			{showOldLayout ?
				<MyBetsLayout1 {...props} />
				:
				<MyBetsLayout2 {...props} />
			}
		</>
	);
}

export default MyBets;